import React, { FC, memo } from 'react'
import './ErrorMessage.scss'
import Warning from '../Icons/Warning';

/**
 * ErrorMessage Props Interface
 * @interface ErrorMessageProps
 */

interface ErrorMessageProps {
  /** Unique identifier for the error message */
  id?: string;
  /** The error message to display */
  message: string;
  /** Additional CSS class names */
  className?: string;
  /** Whether to show the warning icon */
  showIcon?: boolean;
}

/**
 * ErrorMessage Component
 * A reusable error message component that displays validation errors
 * with proper accessibility attributes and optional warning icon.
 */
const ErrorMessage: FC<ErrorMessageProps> = ({
  id,
  message,
  className = '',
  showIcon = true
}) => {
  if (!message || typeof message !== "string") return null;

  return (
    <div
      id={id}
      className={`error-message ${className}`.trim()}
      role="alert"
      aria-live="polite"
    >
      {showIcon && (
        <span className="error-message__icon" aria-hidden="true">
          <Warning width={"18"} height={"18"} color={"#e52514"} />
        </span>
      )}
      <span className="error-message__text">{" "}{message}</span>
    </div>
  );
};

export default memo(ErrorMessage);
